import { helpText, HelpTextVariantProps } from "./help-text.variants";

export type UseHelpTextProps = HelpTextVariantProps & {
  className?: string;
  children?: React.ReactNode;
};

export const useHelpText = (props: UseHelpTextProps) => {
  const {
    className = "",
    children,
    status = "default",
    floating = true,
    ...componentProps
  } = props;

  const styles = helpText({
    status,
    floating,
  });

  return {
    styles,
    className,
    children,
    componentProps,
  };
};
